import Home from '../../views/front/home';
import AboutUs from '../../views/front/AboutUs';
import ActivationAccount from '../../views/front/account/ActivationAccount';
import Basket from '../../views/front/basket';
import Calculator from "../../views/front/calculator";
import { Checkout, CheckoutSuccess } from "../../views/front/checkout";
import Contacts from '../../views/front/Contacts';
import CompanyPage from '../../views/front/account/company-page';
import CompanyPageGeneral from '../../views/front/account/company-page/CompanyPageGeneral';
import Companies from '../../views/front/companies/Companies';
import CommercialPolicy from '../../views/front/account/commercial-policy';
import Categories from '../../views/front/categories';
import Faq from '../../views/front/faq';
import Login from '../../views/front/account/Login';
import News from '../../views/front/News';
import NewOrder from '../../views/front/new-purchase';
import NewsSingle from '../../views/front/NewsSingle';
import NotFound from '../../views/front/not-found';
import {ProductAddView as ProductAdd} from '../../views/front/account/products';
import {ProductUpdateView as ProductUpdate} from '../../views/front/account/products';
import ProductCard from '../../views/front/product-card/ProductCard';
import ProductAttribute from '../../views/front/product-attribute';
import ProductRegion from '../../views/front/product-region';
import Products from '../../views/front/products/Products';
import ProductsCompare from '../../views/front/products-compare/ProductsCompare';
import Profile from '../../views/front/account/Profile';
import ProfileBasket from '../../views/front/account/ProfileBasket';
import ProfileContracts from '../../views/front/account/ProfileContracts';
import ProfileFavorites from '../../views/front/account/ProfileFavorites';
import ProfileHelp from '../../views/front/account/ProfileHelp';
import ProfileMessages from '../../views/front/account/ProfileMessages';
import ProfilePay from '../../views/front/account/ProfilePayInfo';
import ProfilePersonal from '../../views/front/account/ProfilePersonal';
import ProfileProducts from '../../views/front/account/ProfileProducts';
import ProfileSales from '../../views/front/account/ProfileSales';
import RegionsList from "../../views/front/regions-list/RegionsList";
import Registration from '../../views/front/account/Registration';
import ForgetPassword from '../../views/front/account/ForgetPassword';
import ResetPassword from '../../views/front/account/ResetPassword';
import SellerCard from '../../views/front/SellerCard';
import SetCredentials from '../../views/front/account/SetCredentials';
import TextPage from '../../views/front/text-page';
import CategoriesList from "../../views/front/categories-list/CategoriesList";


const defaultLocale = 'ua';
const appLocales = {'ru' : 'ru', 'ua' : 'ua'};
const locale = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');
const currentLocale = appLocales[locale];
const appLocale = (currentLocale && currentLocale !== defaultLocale) ? currentLocale : '';

const routes = {
    base: appLocale,
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
            name: 'home'
        },
        {
            path: '/about-us',
            component: AboutUs,
            name: 'aboutUs'
        },
        {
            path: '/account/activate/:hash',
            component: ActivationAccount,
            name: 'activationAccount',
            props: true
        },
        {
            path: '/account/password/forget',
            component: ForgetPassword,
            name: 'forgetPassword',
        },
        {
            path: '/account/password/find/:hash',
            component: ResetPassword,
            name: 'resetPassword',
            props: true
        },
        {
            path: '/auth/credentials',
            component: SetCredentials,
            name: 'setCredentials',
        },
        {
            path: '/basket',
            component: Basket,
            name: 'Basket'
        },
        {
            path: '/calculator',
            component: Calculator,
            name: 'calculator',
        },
        {
            path: '/calculator/:id',
            component: Calculator,
            name: 'calculatorWithResults',
            props: true
        },
        {
            path: '/categories/:alias',
            component: Categories,
            name: 'categoriesSub',
            props: true
        },
        {
            path: '/categories/:parent/:alias',
            component: Categories,
            name: 'categories',
            props: true
        },
        {
            path: '/categories',
            component: CategoriesList,
            name: 'categoriesList'
        },
        {
            path: '/checkout',
            component: Checkout,
            name: 'checkout'
        },
        {
            path: '/checkout/success',
            component: CheckoutSuccess,
            name: 'checkoutSuccess',
        },
        {
            path: '/contacts',
            component: Contacts,
            name: 'contacts'
        },
        {
            path: '/companies',
            component: Companies,
            name: 'companies'
        },
        {
            path: '/faq',
            component: Faq,
            name: 'Faq'
        },
        {
            path: '/login',
            component: Login,
            name: 'login'
        },
        {
            path: '/news',
            component: News,
            name: 'news'
        },
        {
            path: '/news/:alias',
            component: NewsSingle,
            props: true,
            name: 'newsSingle'
        },
        {
            path: '/orders/add',
            component: NewOrder,
            name: 'newOrder'
        },
        {
            path: '/404',
            component: NotFound,
            name: 'notFound'
        },
        {
            path: '/products',
            component: Products,
            name: 'products'
        },
        {
            path: '/products/add',
            component: ProductAdd,
            name: 'productAdd',
        },
        {
            path: '/products/compare',
            component: ProductsCompare,
            name: 'productsCompare'
        },
        {
            path: '/products/attribute/:attribute/:systemValue',
            component: ProductAttribute,
            name: 'productsAttribute',
            props: true
        },
        {
            path: '/products/:parentCategory/:category/:sysNameWithId',
            component: ProductCard,
            name: 'product',
            props: true
        },
        {
            path: '/profile',
            component: Profile,
            name: 'profile',
        },
        {
            path: '/profile/basket',
            component: ProfileBasket,
            name: 'profileBasket',
        },
        {
            path: '/profile/contracts',
            component: ProfileContracts,
            name: 'profileContracts',
        },
        {
            path: '/profile/company',
            component: CompanyPage,
            name: 'companyPage',
        },
        {
            path: '/companies/:id',
            component: CompanyPageGeneral,
            name: 'companyPageGeneral',
            props: true
        },
        {
            path: '/profile/commercial-policy',
            component: CommercialPolicy,
            name: 'commercialPolicy',
        },
        {
            path: '/profile/favorites',
            component: ProfileFavorites,
            name: 'profileFavorites',
        },
        {
            path: '/profile/help',
            component: ProfileHelp,
            name: 'profileHelp',
        },
        {
            path: '/profile/messages',
            component: ProfileMessages,
            name: 'profileMessages',
        },
        {
            path: '/profile/pay-info',
            component: ProfilePay,
            name: 'profilePay',
        },
        {
            path: '/profile/personal-info',
            component: ProfilePersonal,
            name: 'profilePersonal',
        },
        {
            path: '/profile/products',
            component: ProfileProducts,
            name: 'profileProducts',
        },
        {
            path: '/profile/products/update/:id',
            component: ProductUpdate,
            name: 'profileProductsUpdate',
            props: true
        },
        {
            path: '/profile/sales',
            component: ProfileSales,
            name: 'profileSales',
        },
        {
            path: '/registration',
            component: Registration,
            name: 'registration',
        },
        {
            path: '/regions/:alias',
            component: ProductRegion,
            name: 'productsRegion',
            props: true
        },
        {
            path: '/regions',
            component: RegionsList,
            name: 'regionsList'
        },
        {
            path: '/sellers/:alias',
            component: SellerCard,
            name: 'sellerCard',
            props: true
        },
        {
            path: '/info/:pageName',
            component: TextPage,
            name: 'textPage',
            props: true
        },
    ]
};

export default routes;
